/**
 * Zwischenspeicher für „Sind Dauer-Etiketten verfügbar?“ (je Sitzung, im Modul). Ohne ihn lüde jede Stelle, die den Hinweis oder
 * Link zeigt, bei jedem Einbinden die ganze Liste der Codes. Nur eine eindeutige Antwort (Liste geladen oder 404) wird gemerkt, nie
 * ein Fehler. Der Eintrag verfällt nach `POOL_AVAILABLE_MAX_AGE_MS` und wird beim An- und Abmelden verworfen (die Antwort gehört
 * zur Person). Eigene Datei ohne Abhängigkeiten, damit das Test-Setup sie zurücksetzen kann.
 */
export const POOL_AVAILABLE_MAX_AGE_MS = 5 * 60_000;

interface Entry {
  at: number;
  promise: Promise<boolean>;
}

let cache: Entry | null = null;

/**
 * Liefert die zwischengespeicherte Antwort oder startet `load` (liefert `true`/`false` bei eindeutiger Antwort, wirft bei einem
 * Fehler). Gleichzeitige Aufrufer teilen sich einen Abruf. Ein Fehler wird nicht gemerkt und ergibt `false`.
 */
export function poolLabelsAvailability(
  load: () => Promise<boolean>,
  now = Date.now(),
): Promise<boolean> {
  if (cache !== null && now - cache.at < POOL_AVAILABLE_MAX_AGE_MS) return cache.promise;
  const entry: Entry = { at: now, promise: load() };
  cache = entry;
  const settled = entry.promise.catch(() => {
    if (cache === entry) cache = null;
    return false;
  });
  // Die Aufrufer sehen nie eine Ablehnung: Fehler gelten als „nicht verfügbar“
  entry.promise = settled;
  return settled;
}

/** Zwischenspeicher verwerfen (Anmelden, Abmelden, Tests). */
export function resetPoolLabelsAvailable(): void {
  cache = null;
}
